import api from "@/lib/api";
import type {
  ApiUser,
  UserBasicResponse,
  UsersCreationPayload,
  UsersListParams,
} from "../types";
import type { PaginatedQueryResult } from "@/types";

const USERS_ENDPOINTS = {
  LIST: "/users/",
  GET_ONE: (id: string) => `/users/${id}/`,
  CREATE: "/users/invite/",
  UPDATE: (id: string) => `/users/${id}/`,
  DELETE: (id: string) => `/users/${id}/`,
  BULK_UPDATE: "/users/bulk_update/",
  BULK_DESTROY: "/users/bulk_destroy/",
};

export class UsersHttpRepository {
  async fetchList(
    params?: UsersListParams,
  ): Promise<PaginatedQueryResult<ApiUser>> {
    const result = await api.get(USERS_ENDPOINTS.LIST, { params });
    return result.data;
  }
  async fetchOne(id: string): Promise<ApiUser> {
    const result = await api.get(USERS_ENDPOINTS.GET_ONE(id));
    return result.data;
  }
  async create(payload: UsersCreationPayload): Promise<UserBasicResponse> {
    const result = await api.post(USERS_ENDPOINTS.CREATE, payload);
    return result.data;
  }
  async update(
    id: string,
    payload: UsersCreationPayload,
  ): Promise<UserBasicResponse> {
    const result = await api.put(USERS_ENDPOINTS.UPDATE(id), payload);
    return result.data;
  }
  async patch(
    id: string,
    payload: Partial<UsersCreationPayload & { status: string }>,
  ): Promise<UserBasicResponse> {
    const result = await api.patch(USERS_ENDPOINTS.UPDATE(id), payload);
    return result.data;
  }
  async delete(id: string) {
    const result = await api.delete(USERS_ENDPOINTS.DELETE(id));
    return result.data;
  }
  async bulkUpdate(payload: { id: string; status: string }[]) {
    const result = await api.patch(USERS_ENDPOINTS.BULK_UPDATE, payload);
    return result.data;
  }
  async bulkDestroy(payload: { id: string }[]) {
    const result = await api.delete(USERS_ENDPOINTS.BULK_DESTROY, {
      data: payload,
    });
    return result.data;
  }
}
